import { Box, Grid, LinearProgress, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { daysInYear } from "utils";

const MIN = 0;

const LinearProgressStats = (props) => {
  const { title, days, xs = 12, sm = 7, avatarcolor } = props;
  const { t } = useTranslation();
  const MAX = daysInYear();

  return (
    <Grid
      item
      container
      xs={xs}
      sm={sm}
      display="flex"
      alignItems="center"
      justifyContent="center"
      spacing={2}
    >
      <Grid item xs={12}>
        <Typography align="center" variant="h6" color="white">
          {t(title)}
        </Typography>
      </Grid>
      {days !== undefined && days !== null ? (
        <Grid
          item
          container
          xs={12}
          display="flex"
          justifyContent="space-between"
        >
          <Grid
            item
            container
            xs={8}
            mt={0.5}
            ml={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={11}>
              <LinearProgress
                variant="determinate"
                value={(days * 100) / MAX}
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #fff",
                  "& .MuiLinearProgress-bar1Determinate": {
                    backgroundColor: `${avatarcolor}A6`,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  sx={{ fontSize: 10, marginLeft: "1%", opacity: 0.9 }}
                >
                  {MIN}
                </Typography>

                <Typography
                  sx={{ fontSize: 10, marginRight: "-1%", opacity: 0.9 }}
                >
                  {MAX}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={3} mt={-0.5}>
            <Typography align="center" sx={{ fontSize: 10 }}>
              {`${days} / ${MAX}`}
            </Typography>
            <Typography
              align="center"
              sx={{
                fontSize: 10,
                lineHeight: 0.8,
                textTransform: "lowercase",
              }}
            >
              {t("Days")}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography
            align="center"
            variant="h6"
            sx={{ color: "white", opacity: 0.9 }}
          >
            {t("Data not available")}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default LinearProgressStats;
